// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.token-card-active-border {
  border: var(--cds-alias-object-border-width-100) solid var(--clr-card-clickable-border-color);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/modals/token-table/token-table.component.scss"],"names":[],"mappings":"AAAA;EACI,6FAAA;AACJ","sourcesContent":[".token-card-active-border {\n    border: var(--cds-alias-object-border-width-100) solid var(--clr-card-clickable-border-color);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
